import { useAppState } from 'state/hooks/app.state.hook';
import './style.scss';
import { useTranslation } from 'react-i18next';
import { useLayoutEffect, useState } from 'react';
import { PopupDialog } from '@appcharge/shared-ui';

export const InfoModal: React.FC = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { infoModalUrl, closeInfoModal, setDisplayLoader } = useAppState();
  const { t } = useTranslation();

  useLayoutEffect(() => {
    if (!infoModalUrl) return;
    setIsLoading(true);
    setDisplayLoader(true);
  }, [infoModalUrl]);

  const handleClose = () => {
    if (isLoading) setDisplayLoader(false);
    closeInfoModal();
  };

  return (
    <PopupDialog
      open={!!infoModalUrl}
      onClose={handleClose}
      ariaLabel={t('infoModal.legalInfo')}
      className="infoModalOverlay"
      backdropColor={isLoading ? 'transparent' : undefined}
    >
      <div className="infoModal" style={{ visibility: isLoading ? 'hidden' : 'visible' }}>
        <span onClick={handleClose}>X</span>
        <iframe
          title={t('infoModal.legalInfo')}
          src={infoModalUrl ?? ''}
          onLoad={() => {
            setDisplayLoader(false);
            setIsLoading(false);
          }}
          style={{ width: '100%', height: '100%' }}
        />
      </div>
    </PopupDialog>
  );
};
